<template>
  <div>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          {{ $t('header.admin.accessRequests') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
      >
        <template #[`item.tenantId`]="{ value }">
          <div class="d-flex align-center" style="gap: 1rem;">
            <ClipboardCopy>
              {{ value }}
            </ClipboardCopy>
            <v-chip v-if="!allowedTenantIds.includes(value)" small label color="warning">
              Unknown
            </v-chip>
          </div>
        </template>
        <template #[`item.federationReference`]="{ value }">
          <ClipboardCopy>
            {{ value }}
          </ClipboardCopy>
        </template>
        <template #[`item.action`]="{ item }">
          <div class="d-flex justify-end" style="gap: .5rem;">
            <v-btn @click="$router.push({ path: '/admin/user-create', query: item })">
              {{ $t('accessRequests.grantAccess') }}
            </v-btn>
            <v-btn :loading="deleting" @click="deleteItem(item.id)">
              <v-icon color="error">
                mdi-delete-outline
              </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { msal } from '@/assets/config.json'
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default {
  name: 'AccessRequests',
  components: {
    ClipboardCopy
  },
  data() {
    return {
      loading: true,
      deleting: false,
      items: [],
      headers: [
        {
          text: this.$t('common.name'),
          value: 'name'
        },
        {
          text: this.$t('common.email'),
          value: 'email'
        },
        {
          text: 'Federation reference',
          value: 'federationReference'
        },
        {
          text: 'Tenant ID',
          value: 'tenantId'
        },
        {
          text: '',
          value: 'action',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    allowedTenantIds() {
      return msal?.allowedTenantIds?.split(',');
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('access-requests');

        this.items = data;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    },
    deleteItem: async function(id) {
      this.deleting = true;

      try {
        const { data } = await this.$api.delete('access-requests/' + id)

        if (!data.success) {
          throw data.errors[0] ?? 'Something happened'
        }

        this.$notifier.showSuccess({ message: 'Access request deleted' });
        this.getData();
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.deleting = false;
      }
    }
  }
}
</script>